export default {
  email: 'メールアドレス',
  password: 'パスワード',
  remember_me: 'メールアドレスとパスワードを保存する',
  login: 'ログイン',
  forgot_password: 'パスワードをお忘れの方',
  logout: 'ログアウト'
};
